import useFlag, { FLAGS } from "@coworker/app/src/hooks/useFlag";
import { CreateMediaView } from "@coworker/app/src/components/RoomSettings/Medias/CreateMediaView";
import { CreateMediaPage } from "./CreateMediaPage/CreateMediaPage";

export const CreateMediaLandingPage = () => {
  const enableLaunchMedia = useFlag(FLAGS.ENABLE_LAUNCH_MEDIA);

  if (enableLaunchMedia) {
    return <CreateMediaPage />;
  }

  return <CreateMediaView />;
};
